<template>
  <section class="bloc-recipe">
      <div class="bloc-recipe__col-left scroll-step js-scroll-show" ref="colLeft" :style="{ top: colLefTop + 'px' }">
        <div class="chef">
          <img :src="require(`@/${content.chef.img}`)" alt="" class="chef-img">
          <div class="infos">
            <div class="chef-infos">
              <h2 class="name">{{ content.chef.status }} {{ content.chef.name }}</h2>
              <div class="restaurant"><span>{{ content.chef.restaurant }}</span>&nbsp;<span>{{ content.chef.place }}</span></div>
            </div>
            <div class="recipe-infos">
              <div class="persons">
                <img svg-inline src="@/assets/images/icons/book.svg" />
                <span class="title">{{ content.recipe.infos.persons.title }}</span>
                <span class="text">{{ content.recipe.infos.persons.text }}</span>
              </div>
              <div class="preparation">
                <img svg-inline src="@/assets/images/icons/preparation.svg" />
                <span class="title">{{ content.recipe.infos.preparation.title }}</span>
                <span class="text" v-html="content.recipe.infos.preparation.text"></span>
              </div>
              <div class="cooking">
                <img svg-inline src="@/assets/images/icons/cooking.svg" />
                <span class="title">{{ content.recipe.infos.cooking.title }}</span>
                <div class="text" v-html="content.recipe.infos.cooking.text"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="imgs">
          <div v-for="(img, i) in content.recipe.imgs" :key="i" >
            <img :src="require(`@/${img}`)" alt="" class="img">
          </div>
        </div>
      </div>

      <div class="bloc-recipe__col-right scroll-step js-scroll-show show-delay-100"  ref="colRight" :style="{ top: colRightTop + 'px' }">
        <span class="surtitle">{{ content.recipe.surtitle }}</span>
        <h1 v-html="content.recipe.title" />

        <div class="section-ingredients">
          <h2 class="title">{{content.recipe.ingredients_section.title }}</h2>
          <ul v-if="!content.recipe.ingredients_section.firstItemsIsMain" class="list">
            <li v-for="(item, i) in (content.recipe.ingredients_section.items)" :key="i" class="item">
              <span class="item-title">{{ item.title }}</span>
              <div v-html="item.text" class="item-text"></div>
            </li>
          </ul>
           <ul v-else class="list has-main-item">
              <li class="item item-main">
                <span class="item-title">{{ content.recipe.ingredients_section.items[0].title }}</span>
                <div v-html="content.recipe.ingredients_section.items[0].text" class="item-text"></div>
              </li>
              <ul>
                <li v-for="(item, i) in (content.recipe.ingredients_section.items.slice(1, content.recipe.ingredients_section.items.length))" :key="i" class="item">
                  <span class="item-title">{{ item.title }}</span>
                  <div v-html="item.text" class="item-text"></div>
                </li>
              </ul>
          </ul>
        </div>

        <div class="section-procedure">
          <h2 class="title">{{content.recipe.procedure_section.title }}</h2>
          <ul class="list">
            <li v-for="(item, i) in (content.recipe.procedure_section.items)" :key="i" class="item">
              <div class="title-ctn">
                <span class="number">{{ i + 1 }}</span>
                <span class="item-title">{{ item.title }}</span>
              </div>
              <div v-html="item.text" class="item-text"></div>
            </li>
          </ul>
        </div>
        
        <div class="section-service">
          <span class="section-title">{{ content.recipe.service_section.title }}</span>
          <div v-html="content.recipe.service_section.text" class="section-text"></div>
        </div>

        <div class="section-notes" v-if="content.recipe.notes_section">
          <h3 class="section-title">{{content.recipe.notes_section.title }}</h3>
          <div v-html="content.recipe.notes_section.text" class="section-text"></div>
        </div>
        
      </div>

      <div class="mobile-imgs">
        <div v-for="(img, i) in content.recipe.imgs" :key="i" >
          <img :src="require(`@/${img}`)" alt="" class="img">
        </div>
      </div>
  </section>
</template>

<script>
import store from '@/store/store'
import signals from '@/store/signals'

export default {
  name: 'TextCta',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      colLefTop: 80,
      colRightTop: null
    }
  },
  mounted () {
    this.bind()
    this.setheight()
  },
  methods: {
    bind () {
      // store.resize.listen(this.setheight)
      signals.resizeEnd.listen(this.setheight)
    },
    setheight() {
      this.colLefTop = window.innerHeight - this.$refs?.colLeft?.offsetHeight
      this.colRightTop = window.innerHeight - this.$refs?.colRight?.offsetHeight
    },
    unbind () {
      signals.resizeEnd.unlisten(this.setheight)
    },
    beforeUnmount () {
      this.unbind()
    }
  }
}
</script>

<style lang="scss">
  .bloc-recipe {
    width: 100vw;
    background: $th-white;
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    @include media($from: small) {
      flex-direction: row;
    }

    &__col-left {
      width: 100%;
      position: relative;

      @include media($until: small) {
        top: initial !important;
      }

      @include media($from: small) {
        width: 50%;
        position: sticky;
        // top: calc(100vh - 1462px);
        // top: rem(80);
      }

      .chef {
        position: relative;
        width: 100%;
        height: grid_m(6, 5);

        @include media($from: small) {
          height: grid(6.25, 5);
        }

        .chef-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .infos {
          position: absolute;
          width: 100%;
          display: flex;
          bottom: 0;
          padding: rem(20) rem(25);
          color: $th-cherry;
          background: rgba($color: $th-white, $alpha: 0.8);
          flex-direction: column;

          @include media($from: small) {
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            padding: rem(20) rem(35);
          }

          .chef-infos {
            .name {
              @include paragraph($type: 'medium-gotham-bold', $color: $th-cherry, $uppercase: true);
            }

            .restaurant {
               @include paragraph($type: 'medium', $color: $th-cherry, $uppercase: false);
               font-size: rem(19);
               margin-top: rem(3);
            }
          }

          .recipe-infos {
            display: flex;
            margin-top: rem(15);

            @include media($from: small) {
              margin-top: 0;
            }

            .persons,
            .preparation,
            .cooking {
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-right: rem(14);

              @include media($from: small) {
                margin-right: 0;
                margin-left: rem(24);
              }

              img {
                height: rem(20);
                width: auto;

                @include media($from: small) {
                  height: rem(30);
                }
              }

              .title {
                @include paragraph($type: 'small-2-gotham-bold', $color: $th-cherry, $uppercase: true);
                margin-top: rem(8);
              }

              .text {
                @include paragraph($type: 'small-2-gotham', $color: $th-cherry, $uppercase: false);

                .small {
                  font-size: rem(10);
                }
              }
            }
          }
        }
      }

      > .imgs {
        width: 100%;
        display: none;

        @include media($from: small) {
          display: block;
        }

        > div {
          width: 100%;
          height: grid(6.5, 5);
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    &__col-right {
      width: 100%;
      padding: rem(35);
      border: rem(8) $th-yellow solid;
      position: relative;

      @include media($until: small) {
        top: initial !important;
      }

      @include media($from: small) {
        border: rem(12) $th-yellow solid;
        width: 50%;
        position: sticky;
        padding: rem(60) rem(70);
      }

      .surtitle {
        @include paragraph($type: 'medium-krug-hand', $color: $th-yellow, $uppercase: false);
        font-style: italic;
        text-align: center;
        display: block;
      }

      h1 {
        @include paragraph($type: 'big-gotham-bold', $color: $th-cherry, $uppercase: true);
        text-align: center;
        position: relative;
        margin-top: rem(15);
        font-size: rem(24);
        line-height: 1.2;

        &::after {
          content: "";
          width: 45%;
          height: 1px;
          left: 50%;
          bottom: rem(-25);
          position: absolute;
          display: block;
          transform: translate(-50%);
          background: $th-cherry;
        }
      }

      .section-ingredients {
        margin-top: rem(70);

        .title {
          @include paragraph($type: 'medium-gotham', $color: $th-cherry, $uppercase: true);
        }

        .list {
          display: flex;
          flex-wrap: wrap;
          margin-top: rem(20);

          .item {
            width: 50%;
            margin-bottom: rem(20);
            padding-right: rem(20);

            @include media($from: small) {
              width: 33%;
            }

            .item-title {
              @include paragraph($type: 'medium-2-bold', $color: $th-cherry, $uppercase: false);
            }

            .item-text {
              @include paragraph($type: 'normal', $color: $th-grey-2, $uppercase: false);
              line-height: 1.2;
              margin-top: rem(5);
            }
          }
        }

        .list.has-main-item {
          .item-main {
            width: 100%;
            margin-bottom: rem(20);
            padding-right: rem(20);

            @include media($from: small) {
              width: 33%;
            }
          }

          > ul {
            display: flex;
            flex-wrap: wrap;
            width: 100%;

            @include media($from: small) {
              width: 66%;
            }

            .item {
              width: 50%;
              margin-bottom: rem(20);
              padding-right: rem(20);
            }
          }
        }
      }

      .section-procedure {
        margin-top: rem(40);

        .title {
          @include paragraph($type: 'medium-gotham', $color: $th-cherry, $uppercase: true);
        }

        .list {
          margin-top: rem(30);

          .item {
            width: 100%;
            padding-bottom: rem(30);
            padding-right: rem(20);
            position: relative;

            &:last-of-type {
               &::after {
                display: none;
               }
            }

            &::after {
              content: "";
              width: 2px;
              height: 100%;
              left: rem(-20);
              top: rem(5);
              position: absolute;
              display: block;
              background: $th-yellow;

              @include media($from: small) {
                left: rem(-37);
                top: 0;
              }
            }

            .title-ctn {
              display: flex;
              align-items: center;
              z-index: 1;
              position: relative;
            }

            .number {
              @include paragraph($type: 'small-2-gotham-bold', $color: $th-cherry, $uppercase: true);
              position: absolute;
              left: rem(-28);
              background: $th-yellow;
              border-radius: 50%;
              width: rem(18);
              height: rem(18);
              display: flex;
              justify-content: center;
              align-items: center;

              @include media($until: small) {
                font-size: rem(9);
              }

              @include media($from: small) {
                left: rem(-50);
                width: rem(28);
                height: rem(28);
              }
            }

            .item-title {
              @include paragraph($type: 'medium-2-bold', $color: $th-cherry, $uppercase: false);
            }

            .item-text {
              @include paragraph($type: 'normal', $color: $th-grey-2, $uppercase: false);
              line-height: 1.25;
              margin-top: rem(14);
            }
          }
        }
      }

      .section-service {
        .section-title {
          @include paragraph($type: 'medium-2-bold', $color: $th-cherry, $uppercase: false);
        }

        .section-text {
          @include paragraph($type: 'normal', $color: $th-grey-2, $uppercase: false);
          line-height: 1.25;
          margin-top: rem(14);
        }
      }

      .section-notes {
        position: relative;
        margin-top: rem(80);
        margin-bottom: rem(50);
        
        &::before {
          content: "";
          width: 45%;
          height: 1px;
          left: 50%;
          top: rem(-35);
          position: absolute;
          display: block;
          transform: translate(-50%);
          background: $th-cherry;
        }

        &::after {
          content: "";
          width: 45%;
          height: 1px;
          left: 50%;
          bottom: rem(-35);
          position: absolute;
          display: block;
          transform: translate(-50%);
          background: $th-cherry;
        }
        
        .section-title {
          @include paragraph($type: 'medium-krug-hand', $color: $th-yellow, $uppercase: false);
          font-style: italic;
          text-align: center;
        }

        .section-text {
          @include paragraph($type: 'big', $color: $th-grey-2, $uppercase: false);
          text-align: center;
          margin-top: rem(20);
        }
      }
    }

    .mobile-imgs {
      width: 100%;
      display: block;

      @include media($from: small) {
        display: none;
      }

      > div {
        width: 100%;
        height: grid_m(6, 5);

        @include media($from: small) {
          height: grid(6.5, 5);
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
</style>
